var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84.106,
    height: 120.392,
    viewBox: "102.958 52.2402 84.106 120.392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.904 73.7282C179.904 74.8328 179.009 75.7282 177.904 75.7282H129.29C128.185 75.7282 127.29 76.6237 127.29 77.7282V100.916C127.29 102.56 129.258 103.405 130.45 102.272C136.559 96.4789 142.563 93.5822 148.462 93.5822H160.312C166.632 93.5822 172.004 95.7942 176.428 100.218C180.852 104.642 183.064 110.014 183.064 116.334V145.88C183.064 152.2 180.852 157.572 176.428 161.996C172.004 166.42 166.632 168.632 160.312 168.632H125.71C119.39 168.632 114.018 166.42 109.594 161.996C105.17 157.572 102.958 152.2 102.958 145.88V135.714C102.958 134.61 103.853 133.714 104.958 133.714H123.71C124.815 133.714 125.71 134.61 125.71 135.714V140.824C125.71 145.038 127.817 147.144 132.03 147.144H153.992C158.205 147.144 160.312 145.038 160.312 140.824V120.126C160.312 115.913 158.205 113.806 153.992 113.806H146.25C140.457 113.806 135.19 115.228 130.45 118.072L128.04 119.518C127.562 119.805 126.986 119.88 126.451 119.723L105.978 113.752C105.125 113.503 104.538 112.721 104.538 111.832V56.2402C104.538 55.1357 105.433 54.2402 106.538 54.2402H177.904C179.009 54.2402 179.904 55.1357 179.904 56.2402V73.7282Z",
    fill: "#4E0109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.904 73.7282C179.904 74.8328 179.009 75.7282 177.904 75.7282H129.29C128.185 75.7282 127.29 76.6237 127.29 77.7282V100.916C127.29 102.56 129.258 103.405 130.45 102.272C136.559 96.4789 142.563 93.5822 148.462 93.5822H160.312C166.632 93.5822 172.004 95.7942 176.428 100.218C180.852 104.642 183.064 110.014 183.064 116.334V145.88C183.064 152.2 180.852 157.572 176.428 161.996C172.004 166.42 166.632 168.632 160.312 168.632H125.71C119.39 168.632 114.018 166.42 109.594 161.996C105.17 157.572 102.958 152.2 102.958 145.88V135.714C102.958 134.61 103.853 133.714 104.958 133.714H123.71C124.815 133.714 125.71 134.61 125.71 135.714V140.824C125.71 145.038 127.817 147.144 132.03 147.144H153.992C158.205 147.144 160.312 145.038 160.312 140.824V120.126C160.312 115.913 158.205 113.806 153.992 113.806H146.25C140.457 113.806 135.19 115.228 130.45 118.072L128.04 119.518C127.562 119.805 126.986 119.88 126.451 119.723L105.978 113.752C105.125 113.503 104.538 112.721 104.538 111.832V56.2402C104.538 55.1357 105.433 54.2402 106.538 54.2402H177.904C179.009 54.2402 179.904 55.1357 179.904 56.2402V73.7282Z",
    fill: "url(#paint0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter05",
    x: 102.958,
    y: 52.2402,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.921569 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0",
    x1: 143.011,
    y1: 54.2402,
    x2: 212.379,
    y2: 140.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.398452,
    stopColor: "#C40F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8102E",
    stopOpacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.beb8ff52fa0cbcb5a0326df2d39580a5.svg";
export { ForwardRef as ReactComponent };